;(() => {
  const track = document.querySelector("[data-slideshow-track]")
  const prevBtn = document.querySelector("[data-slideshow-prev]")
  const nextBtn = document.querySelector("[data-slideshow-next]")
  const dots = document.querySelectorAll("[data-slide-to]")

  if (!track) return

  const slides = track.children
  const totalSlides = slides.length

  if (totalSlides <= 1) return

  let currentSlide = 0
  let autoplayInterval

  // Get config from data attributes (passed from Liquid)
  const autoplayEnabled = track.dataset.autoplayEnabled !== "false"
  const autoplayDelay = Number.parseInt(track.dataset.autoplayDelay) || 5000

  function goToSlide(index) {
    if (index < 0) {
      currentSlide = totalSlides - 1
    } else if (index >= totalSlides) {
      currentSlide = 0
    } else {
      currentSlide = index
    }

    track.style.transform = `translateX(-${currentSlide * 100}%)`

    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === currentSlide)
    })

    if (autoplayEnabled) {
      clearInterval(autoplayInterval)
      startAutoplay()
    }
  }

  function nextSlide() {
    goToSlide(currentSlide + 1)
  }

  function prevSlide() {
    goToSlide(currentSlide - 1)
  }

  function startAutoplay() {
    if (autoplayEnabled) {
      autoplayInterval = setInterval(nextSlide, autoplayDelay)
    }
  }

  // Event Listeners
  if (prevBtn) prevBtn.addEventListener("click", prevSlide)
  if (nextBtn) nextBtn.addEventListener("click", nextSlide)

  dots.forEach((dot) => {
    dot.addEventListener("click", function () {
      goToSlide(Number.parseInt(this.getAttribute("data-slide-to")))
    })
  })

  // Keyboard Navigation
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") prevSlide()
    if (e.key === "ArrowRight") nextSlide()
  })

  // Touch/Swipe Support
  let touchStartX = 0
  let touchEndX = 0

  track.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX
    },
    { passive: true },
  )

  track.addEventListener(
    "touchend",
    (e) => {
      touchEndX = e.changedTouches[0].screenX
      const swipeThreshold = 50
      if (touchStartX - touchEndX > swipeThreshold) nextSlide()
      if (touchEndX - touchStartX > swipeThreshold) prevSlide()
    },
    { passive: true },
  )

  // Pause autoplay on hover, resume on leave
  track.addEventListener("mouseenter", () => {
    if (autoplayEnabled) clearInterval(autoplayInterval)
  })

  track.addEventListener("mouseleave", () => {
    if (autoplayEnabled) startAutoplay()
  })

  startAutoplay()
})()
